var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 10.5V8.333c0-1.037.464-2.017 1.266-2.73C9.816 4.89 10.891 4.5 12 4.5c1.11 0 2.184.391 2.984 1.103.802.713 1.266 1.693 1.266 2.73V10.5h1c1.09 0 2 .86 2 1.954v5.091c0 1.094-.91 1.955-2 1.955H6.75c-1.09 0-2-.86-2-1.954v-5.091c0-1.094.91-1.955 2-1.955h1zm1.93-4.15c.607-.539 1.44-.85 2.32-.85.88 0 1.713.311 2.32.85.604.537.93 1.252.93 1.983V10.5h-6.5V8.333c0-.73.326-1.446.93-1.983zM6.75 11.5c-.567 0-1 .442-1 .954v5.091c0 .513.433.955 1 .955h10.5c.567 0 1-.442 1-.954v-5.091c0-.513-.433-.955-1-.955H6.75z"
  })));
});
export default SvgLock;